import { type LeftSide, leftSideActions } from '@appStore/reducers/leftSideMenu'
import pageIcon from 'assets/image/icons/left-side-menu/page.svg'
import { helpersFunc } from 'config/helpers'
import { useCallback, useEffect } from 'react'
import { useAppDispatch } from 'shared/hooks'

import type { ImportResponse } from './types'

import { api } from './api'

const SIDE_INFO: LeftSide = {
	bottomList: [
		{
			id: 1,
			image: pageIcon,
			link: '/contacts',
			title: 'All contacts'
		}
	],
	label: 'Recently imported',
	type: 'contacts'
}

export function useInit() {
	const { data, error, status } = api.useRecentsQuery()
	const dispatch = useAppDispatch()

	const update = useCallback(
		(list: ImportResponse[]) => {
			dispatch({
				payload: {
					imports: list
				},
				type: 'RECENT_IMPORTS'
			})

			const sideAction = leftSideActions.setLeftSide({
				...SIDE_INFO,
				list
			})

			dispatch(sideAction)
		},
		[dispatch]
	)

	useEffect(() => {
		switch (status) {
			case 'fulfilled': {
				return update(data ?? [])
			}

			case 'pending':
			case 'uninitialized': {
				return update([])
			}
			case 'rejected': {
				update([])
				return helpersFunc.logEnjectServicePromise(error)
			}
		}
	}, [status, data, error, update])
}
